import { render, staticRenderFns } from "./grower-regions.vue?vue&type=template&id=75ba15e6"
import script from "./grower-regions.vue?vue&type=script&lang=js"
export * from "./grower-regions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports